// This file automatically generated by skymarshal.
// DO NOT MODIFY BY HAND!!!!
//
// From Source File: vehicle/planner/lcmtypes/movement.lcm

import { float } from "@skydio/lcm/src/types";
import { int64_t } from "@skydio/lcm/src/types";

import Long from "long";
import Decoder from "@skydio/lcm/src/decoder";
import Encoder from "@skydio/lcm/src/encoder";
import LcmMsg from "@skydio/lcm/src/lcm";
import ReflectionMeta from "@skydio/lcm/src/reflection";

export class gimbal_roll_command_t extends LcmMsg {

  private static _hash = Long.fromString("13522594049883774884", true);
  private static _packed_fingerprint?: Long;

  /** @internal */
  public static override _get_packed_fingerprint(): Long {
    if (gimbal_roll_command_t._packed_fingerprint === undefined) {
      gimbal_roll_command_t._packed_fingerprint = gimbal_roll_command_t._get_hash_recursive([]);
    }
    return gimbal_roll_command_t._packed_fingerprint;
  }

  /** @internal */
  public static override _get_hash_recursive(parents: any[]): Long {
    if (parents.indexOf(gimbal_roll_command_t) > -1) {
      return Long.fromNumber(0, true);
    }
    let tmp_hash = gimbal_roll_command_t._hash;
    return tmp_hash.shl(1).add(tmp_hash.shru(63));
  }

  /** @internal */
  public static override _reflection_meta: ReflectionMeta = {
    utime: { kind: "primitive", type: Number, typeStr: "int64_t" },
    gimbal_roll: { kind: "primitive", type: Number, typeStr: "float" },
    gimbal_roll_aggressiveness: { kind: "primitive", type: Number, typeStr: "float" },
    gimbal_roll_rate: { kind: "primitive", type: Number, typeStr: "float" },
    gimbal_roll_rate_aggressiveness: { kind: "primitive", type: Number, typeStr: "float" },
    max_gimbal_roll_rate: { kind: "primitive", type: Number, typeStr: "float" },
  };

  public utime: int64_t;
  public gimbal_roll: float;
  public gimbal_roll_aggressiveness: float;
  public gimbal_roll_rate: float;
  public gimbal_roll_rate_aggressiveness: float;
  public max_gimbal_roll_rate: float;

  public override decode(byte_array: Uint8Array): gimbal_roll_command_t {
    const decoder = new Decoder(new DataView(
      byte_array.buffer, byte_array.byteOffset, byte_array.byteLength
    ));
    const hash = decoder.decode_hash();
    if (!hash.equals(gimbal_roll_command_t._get_packed_fingerprint())) {
      console.error("Hash mismatch", hash, gimbal_roll_command_t._get_packed_fingerprint());
      throw new Error("Hash mismatch!");
    }
    this.decode_one(decoder);
    return this;
  }

  public override decode_one(decoder: Decoder): gimbal_roll_command_t {
    this.utime = decoder.decode_int64_t();
    this.gimbal_roll = decoder.decode_float();
    this.gimbal_roll_aggressiveness = decoder.decode_float();
    this.gimbal_roll_rate = decoder.decode_float();
    this.gimbal_roll_rate_aggressiveness = decoder.decode_float();
    this.max_gimbal_roll_rate = decoder.decode_float();
    return this;
  }

  /** @internal */
  public _get_encoded_size(): number {
    let total_size = 0;
    total_size += 8;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    return total_size;
  }

  public override encode(): ArrayBufferLike {
    const encoder = new Encoder(8 + this._get_encoded_size()); // hash + rest
    encoder.encode_hash(gimbal_roll_command_t._get_packed_fingerprint());
    this.encode_one(encoder);

    return encoder.view.buffer;
  }

  public override encode_one(encoder: Encoder): void {
    encoder.encode_int64_t(this.utime);
    encoder.encode_float(this.gimbal_roll);
    encoder.encode_float(this.gimbal_roll_aggressiveness);
    encoder.encode_float(this.gimbal_roll_rate);
    encoder.encode_float(this.gimbal_roll_rate_aggressiveness);
    encoder.encode_float(this.max_gimbal_roll_rate);
  }

  constructor(init?: {utime?: int64_t, gimbal_roll?: float, gimbal_roll_aggressiveness?: float, gimbal_roll_rate?: float, gimbal_roll_rate_aggressiveness?: float, max_gimbal_roll_rate?: float }) {
    super();
    this.utime = 0;
    this.gimbal_roll = 0.0;
    this.gimbal_roll_aggressiveness = 0.0;
    this.gimbal_roll_rate = 0.0;
    this.gimbal_roll_rate_aggressiveness = 0.0;
    this.max_gimbal_roll_rate = 0.0;

    // optionally override default values
    if (!init) {
      return;
    }
    this.utime = init.utime || this.utime;
    this.gimbal_roll = init.gimbal_roll || this.gimbal_roll;
    this.gimbal_roll_aggressiveness = init.gimbal_roll_aggressiveness || this.gimbal_roll_aggressiveness;
    this.gimbal_roll_rate = init.gimbal_roll_rate || this.gimbal_roll_rate;
    this.gimbal_roll_rate_aggressiveness = init.gimbal_roll_rate_aggressiveness || this.gimbal_roll_rate_aggressiveness;
    this.max_gimbal_roll_rate = init.max_gimbal_roll_rate || this.max_gimbal_roll_rate;
  }
}